<template>
    <v-card elevation="1" class="text-left">
        <v-card-title>
            Source List
        </v-card-title>
        <v-card-text>
             <v-text-field 
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details="">
                        </v-text-field>
        </v-card-text>

        <div>
            <v-data-table
            :headers="headers"
            :items="radiationList"
            :search="search"
            :items-per-page="10"
            class="elevation-1"
            >

                
            
            <template #item.radiationId="{value}">
              <a v-on:click.stop.prevent="preventRefresh(`/radiation/updateradiation/${value}`)" target="_blank"><v-icon aria-hidden="false">fas fa-edit</v-icon></a>
            </template>
            
            </v-data-table>
        </div>
        

    </v-card>
</template>

<script>
import radiationAPI from '@/services/radiationservice'

export default {
    name: 'RadiationList',
    data: function(){
        return {
            search: '',
            radiationList:[]
            
        }
    },
    computed:{
        headers(){
            return[
                { text:'', align:'start', sortable:true, value:'radiationId'},
                { text: 'Serial Number', align:'start', sortable:true, value: 'serialNumber'},
                { text:'Building', align:'start', sortable:true, value:'building'},
                { text:'Floor', align:'start', sortable:true, value:'floor'},
                { text:'Location', align:'start', sortable:true, value:'location'},
                { text: 'Has a Shutter', align:'start' , sortable: true, value:'shutt'},
                { text:'Isotope', value:'isotope'},
                { text:'MCI' , value:'mci'},
                //{ text:'Leak Test Interval', align:'start', sortable: true,  value:'leak'},
                { text:'Leak Test Group', align:'start', sortable:true, value:'leakTestGroup'},
                { text: 'Holder', value: 'holder'},
                { text:'Received Date', value:'receiveDate'},
            ]
        }
    },
    mounted:async function(){
        
        
        radiationAPI.getRadiationList()
        .then(response=>{
            this.radiationList=response.data;
        })
        .catch(error=>{console.log(error);})
    },
    methods:{
        filterOnlyCapsText (value, search, item) {

        console.log(item);
        return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().indexOf(search) !== -1
      },
      preventRefresh: function (value){
        
               
        this.$router.push(value);
      }
    }
}
</script>

